import {LocationDisplayOption} from "../interface/display-option";

export interface PortalTrackerOption {
  schools: Array<LocationDisplayOption>;
}
